<template>
  <div class="footDiv">
    <div class="topDiv">
      <ul class="left">
        <router-link tag="li" to="/top">首页</router-link>
        <router-link tag="li" to="/about">关于我们</router-link>
        <router-link tag="li" to="/contactus">联系我们 </router-link>
        <li @click="open" v-if="!$store.state.isMobile">
          App 下载
        </li>
      </ul>

      <div class="right">
        <!-- <i class="el-icon-chat-dot-round"></i>
        <i class="el-icon-chat-dot-round"
           style="margin: 0 7%"></i> -->
        <div>
          <span>020-8920 5833</span>
          <span>周一至周五 9:00-18:00</span>
        </div>
      </div>
    </div>

    <ul class="bottomDiv">
      <li>隐私权政策 | 使用条款</li>
      <li>
        <a href="http://beian.miit.gov.cn/"
          >© 2015-2019 All Rights Reserved.广州车优会联信息科技有限公司
          版权所有粤ICP备15103682号</a
        >
      </li>
      <li style="display:flex;align-items:center;">
        <span>友情链接：</span>
        <a
          :href="item.link"
          v-for="(item, index) in footerlink"
          :key="index"
          v-if="item.link"
        >
          <span>{{ item.title }}</span>
          <span class="shuxian">|</span>
        </a>
        <span v-else class="no-link">
          <span style="padding:0 5px;">{{ item.title }}</span>
          <span class="shuxian">|</span>
        </span>
        <a
          href="https://xyt.xcc.cn/getpcInfo?sn=1425379161214889984&language=CN&certType=8&url=*.uniclub.net"
          target="_blank"
          style="position: relative;margin:0 5px;"
        >
          <div
            style="width:100%;height:100%;position: absolute;top: 0;left: 0;"
          ></div>
          <embed
            src="https://program.xinchacha.com/web/1425379161214889984=*.uniclub.net.svg"
            width="103"
            height="38"
            type="image/svg+xml"
            pluginspage="//www.adobe.com/svg/viewer/install/"
          />
        </a>
        <a
          href="https://xyt.xcc.cn/getpcInfo?sn=1425379161214889984&language=EN&certType=8&url=*.uniclub.net"
          target="_blank"
          style="position: relative;"
        >
          <div
            style="width:100%;height:100%;position: absolute;top: 0;left: 0;"
          ></div>
          <embed
            src="https://program.xinchacha.com/web/1425379161214889984=*.uniclub.neten.svg"
            width="103"
            height="38"
            type="image/svg+xml"
            pluginspage="//www.adobe.com/svg/viewer/install/"
          />
        </a>
        <!-- <span v-else
              >{{item.title}}</span> -->
      </li>
    </ul>
    <service-dialog :show.sync="show"></service-dialog>
  </div>
</template>
<script>
import serviceDialog from "./appdialog";
export default {
  name: "app-footer",
  props: {
    footerlink: {
      type: Array
    }
  },
  data() {
    return {
      show: false
    };
  },
  components: {
    serviceDialog
  },
  methods: {
    open() {
      this.show = true;
    }
  }
};
</script>
<style type="text/scss" lang="scss" scoped>
.footDiv {
  /*position: fixed;*/
  /*left: 0;*/
  /*bottom: 0;*/
  width: 100%;
  background: #282828;
  color: #666666;
  a {
    color: #666666;
    text-decoration: none;
    .shuxian {
      padding: 0 5px;
    }
    &:last-child {
      .shuxian {
        display: none;
      }
    }
  }
  .no-link {
    &:last-child {
      .shuxian {
        display: none;
      }
    }
  }
  .topDiv,
  .bottomDiv {
    margin: 0 13%;
  }
  .topDiv {
    padding-top: 64px;
    display: flex;
    justify-content: space-between;
    .left,
    .right {
      display: flex;
      width: 35%;
    }
    .left {
      justify-content: space-between;
      font-size: 14px;
      cursor: pointer;
    }
    .right {
      justify-content: flex-end;
      div {
        display: flex;
        flex-direction: column;
        font-size: 24px;
        span:nth-last-of-type(1) {
          font-size: 12px;
        }
      }
    }
  }
  .bottomDiv {
    font-size: 12px;
    padding: 50px 0 42px 0;
    text-align: left;
    li:nth-of-type(2) {
      margin: 5px 0;
    }
  }
}
/* 移动端  */
@media all and (max-width: 768px) {
  .footDiv {
    /*position: fixed;*/
    /*left: 0;*/
    /*bottom: 0;*/
    width: 100%;
    background: #282828;
    color: #666666;
    a {
      color: #666666;
      text-decoration: none;
      .shuxian {
        padding: 0 5px;
      }
      &:last-child {
        .shuxian {
          display: none;
        }
      }
    }
    .no-link {
      &:last-child {
        .shuxian {
          display: none;
        }
      }
    }
    .topDiv,
    .bottomDiv {
      margin: 0 10px;
    }
    .topDiv {
      padding-top: 20px;
      display: flex;
      justify-content: space-between;
      .left {
        display: flex;
        width: 50%;
      }

      .right {
        display: flex;
        width: 50%;
      }
      .left {
        justify-content: space-between;
        font-size: 14px;
        cursor: pointer;
      }
      .right {
        justify-content: flex-end;
        div {
          display: flex;
          flex-direction: column;
          font-size: 20px;
          span:nth-last-of-type(1) {
            font-size: 12px;
          }
        }
      }
    }
    .bottomDiv {
      font-size: 12px;
      padding: 20px 0;
      text-align: left;
      li:nth-of-type(2) {
        margin: 5px 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue